import * as React from 'react';
import { Location, LocationParams } from 'lib/componentLocation';
import { IRoute } from 'lib/componentRouter';
import { ManageBerths, ManageBerthsParams, PageMode } from './model';
import { ManageBerthsView } from './view';
import { AppWrapper } from 'portcall/appwrapper/model';
import { AppWrapperView } from 'portcall/appwrapper/view';

export function ManageBerthsRoute(
    model : (params : ManageBerthsParams) => ManageBerths,
    appWrapper : AppWrapper,
    request : Location
) : IRoute {
    const m = model(inboundParams(request));
    return {
        view:
            <AppWrapperView model={appWrapper}>
                <ManageBerthsView model={m} />
            </AppWrapperView>,
        reflectState: () => outboundParams(request, m)
    };
}

function inboundParams(request : Location) : ManageBerthsParams {
    const portId = request.params['portId'],
        mode = request.params['mode'];
    return {
        portId: portId ? +portId : null,
        mode: mode ? +mode : PageMode.View
    };
}

function outboundParams(request : Location, m : ManageBerths) {
    const p = {} as LocationParams;

    if (m.SelectedPortId() !== null) p['portId'] = '' + m.SelectedPortId();
    if (m.PageMode() !== PageMode.View) p['mode'] = '' + m.PageMode();

    return new Location(request.name, p);
}


// WEBPACK FOOTER //
// ./apps/portcall/manageberths/route.tsx